/* eslint-disable */
export const Permissions = {
    Organization_Search__Edit: 'organization_search__edit',
    Organization_Search__Read: 'organization_search__read',
    Organization_Create: 'organization_create',
    Organization_Team__Add: 'organization_team__add',
    Organization_Team__Read: 'organization_team__read',
    Organization_Team__Remove: 'organization_team__remove',
    Organization_Sso_Add: 'organization_sso',
    Organization_Reset_Mfa: 'organization_mfa',
    Application_Overview__Edit: 'application_overview__edit',
    Application_Overview__Read: 'application_overview__read',
    Application_Analytics: 'application_analytics',
    Application_Desk: 'application_desk',
    Application_Desk__Edit: 'application_desk__edit',
    Application_Team: 'application_team',
    Application_Builder: 'application_builder',
    Application_Cloud: 'application_cloud',
    Application_Configurations__Add: 'application_configurations__add',
    Application_Configurations__Edit: 'application_configurations__edit',
    Application_Configurations__Read: 'application_configurations__read',
    Application_Configurations__Remove: 'application_configurations__remove',
    Application_Clone: 'application_clone',
    Application_Migrate: 'application_migrate',
    Application_StatusPage__Read: 'application_statuspage__read',
    Application_StatusPage__Edit: 'application_statuspage__edit',
    Application_Messages__Read: 'application_messages__read',    
    Application_Contacts_State: 'application_contacts_state',
    Application_Contacts_Info: 'application_contacts_info',

    Application_Channels_Sms_Add: 'application_channels_sms_add',
    Application_Channels_Sms_Read: 'application_channels_sms_read',
    Application_Channels_Advanced_Permissions: 'application_channels_advanced_permissions',

    Application_Migrate_CloudApi: 'application_migrate_cloudApi',

    Images_Delete: 'images_delete',

    Scheduler: 'scheduler',
    Images: 'images_delete',
    Account: 'account',

    Billing: 'billing_forms',

    Admin_Identity_Access_Key: 'admin_identity_access_key',

    Procedures: 'procedures'
  }

  Object.freeze(Permissions)
